import styled from 'styled-components';
import { TableContainer, TableHead, TableRow, TableCell, Box, LinearProgress, Chip } from '@mui/material';

export const StyledTableContainer = styled(TableContainer)`
  box-shadow: none !important;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
`;

export const StyledTableHead = styled(TableHead)`
  background-color: #f8fafc;
`;

export const HeaderCell = styled(TableCell)`
  color: #64748b !important;
  font-weight: 600 !important;
  font-size: 0.875rem !important;
  padding: 16px !important;
  border-bottom: 1px solid #e2e8f0 !important;
`;

export const StyledTableRow = styled(TableRow)`
  transition: background-color 0.2s ease-in-out;
  background-color: white;

  &:hover {
    background-color: #f8fafc;
  }
`;

export const DataCell = styled(TableCell)`
  padding: 16px !important;
  border-bottom: 1px solid #f1f5f9 !important;
  color: #1e293b !important;
  font-size: 0.9rem !important;
`;

interface MetricChipProps {
  percentage: number;
}
export const MetricChip = styled(Chip)<MetricChipProps>`
  font-weight: 600 !important;
  font-size: 0.8rem !important;
  background-color: ${props => (props.percentage === 100 ? '#e2f5ec' : '#ffe4e6')} !important;
  color: ${props => (props.percentage === 100 ? '#10b981' : '#f43f5e')} !important;
`;

export const GradeItem = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
  color: #1e293b;
  font-weight: 600;
  font-size: 0.875rem;

  svg {
    font-size: 1.1rem;
    color: #64748b;
  }

  &.overall svg {
    color: #f97316; /* Orange color for the overall star grade */
  }
`;
interface StatusChipProps {
  statusType: 'success' | 'warning' | 'error';
}

export const StatusChip = styled(Chip)<StatusChipProps>`
  font-weight: 600 !important;
  font-size: 0.8rem !important;
  height: 26px !important;

  ${props =>
    props.statusType === 'success' &&
    `
    background-color: #e2f5ec !important;
    color: #10b981 !important;
  `}
  ${props =>
    props.statusType === 'warning' &&
    `
    background-color: #fef3c7 !important;
    color: #d97706 !important;
  `}
  ${props =>
    props.statusType === 'error' &&
    `
    background-color: #f1f5f9 !important;
    color: #64748b !important;
  `}
`;
interface SubmissionProgressProps {
  isComplete: boolean;
}

export const SubmissionProgress = styled(LinearProgress)<SubmissionProgressProps>`
  height: 8px !important;
  border-radius: 4px;
  background-color: #e2e8f0;
  flex-grow: 1;

  & .MuiLinearProgress-bar {
    background-color: ${props => (props.isComplete ? '#10b981' : '#2563eb')} !important;
    border-radius: 4px;
  }
`;
